import { apiSlice } from "../store/app.api";
import { supabase } from "../utils/API";

const authApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getChannels: build.query<any, any>({
      queryFn: async (email: string) => {
        let { data } = await supabase.from("mtrcb_tv_channels").select("*").order('tc_name',{ascending:true});
        return { data };
      },
      providesTags: ["channels"],
    }),
    getPrograms: build.query<any, { scheduleId: string; programDate: string }>({
      queryFn: async (params) => {
        let { data } = await supabase
          .from("tv_schedule_program")
          .select("*")
          .eq("tv_schedule_id", params.scheduleId)
          .eq("program_date", params.programDate);
        return { data };
      },
      providesTags: ["channels"],
    }),
    addChannel: build.mutation<any, any>({
      queryFn: async (channel: any) => {
        let { data } = await supabase.from("channels").insert(channel).single();
        return { data };
      },
      invalidatesTags: ["channels"],
    }),
    addProgram: build.mutation<any, any>({
      queryFn: async (program: any) => {
        let { data } = await supabase
          .from("tv_schedule_program")
          .insert(program)
          .single();
        return { data };
      },
      invalidatesTags: ["channels"],
    }),
    deleteProgram: build.mutation<any, any>({
      queryFn: async (id: any) => {
        let { data } = await supabase
          .from("tv_schedule_program")
          .delete()
          .eq("id", id);
        return { data };
      },
      invalidatesTags: ["channels"],
    }),
    deleteChannel: build.mutation<any, any>({
      queryFn: async (id: any) => {
        let { data } = await supabase.from("channels").delete().eq("id", id);
        return { data };
      },
      invalidatesTags: ["channels"],
    }),

    updateChannel: build.mutation<any, any>({
      queryFn: async (committee: any) => {
        // Ensure the user object has an id field to identify the row to update
        const { id, ...rest } = committee;
        if (!id) {
          return { error: { message: "ID is required for update" } };
        }
        let { data, error } = await supabase
          .from("mtrcb_tv_channels")
          .update(rest)
          .eq("id", id);
        if (error) {
          return { error };
        }

        return { data };
      },
      invalidatesTags: ["appointees"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetChannelsQuery,
  useUpdateChannelMutation,
  useAddChannelMutation,
  useGetProgramsQuery,
  useLazyGetProgramsQuery,
  useAddProgramMutation,
  useDeleteProgramMutation,
  useDeleteChannelMutation,
} = authApi;
